<template>
  <div id="app">
    <!-- 头 -->
    <div class="header">
      <div class="headerContainer">
        <div class="femLogo">
          <img src="./assets/common/femLogo.png"
               alt="">
        </div>
        <ul class="tabList">
          <li class="tabItem"
              :class="tab.routerPath == nowPath ? 'tabItemActive' : ''"
              v-for="tab in tabList"
              :key="tab.id"
              @click="toPath(tab)">{{ tab.text }}</li>
        </ul>
      </div>
    </div>

    <div class="container">
      <router-view />
    </div>

    <!-- 咨询 -->
    <div class="ask">
      <p>一站式服务平台，为您提供智慧社区专业解决方案</p>
      <div class="askButton"
           @click="enter('contact')">点击咨询</div>
    </div>

    <!-- 底 -->
    <div class="footer">
      <div class="footerContainer">
        <ul class="infoList">
          <li class="infoItem"
              v-for="item in bottomList"
              :key="item.id">
            <img :src="item.imgUrl"
                 alt="">
            <span>{{ item.text1 }}</span>
            <span>{{ item.text2 }}</span>
          </li>
        </ul>
        <p>首页 | 关于菲恩曼 | 产品 | 联系我们</p>
        <p>Copyright ©2020 山西太原菲恩曼科技有限 版权所有 站点地图 晋ICP备20004002号</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      tabList: [
        { id: 1, text: '首页', routerPath: 'home' },
        { id: 2, text: '关于菲恩曼', routerPath: 'about' },
        { id: 3, text: '产品', routerPath: 'business' },
        { id: 4, text: '联系我们', routerPath: 'contact' }
      ],

      bottomList: [
        { id: 1, imgUrl: require('./assets/common/address.png'), text1: '山西省/太原市/小店区', text2: '晋阳街/兴业大厦/六层' },
        { id: 2, imgUrl: require('./assets/common/tel.png'), text1: '0351-7037100', text2: '9:00 - 18:00' },
        { id: 3, imgUrl: require('./assets/common/email.png'), text1: 'feienman@', text2: '126.com' }
      ]
    }
  },
  computed: {
    nowPath () {
      return this.$route.name
    }
  },
  methods: {
    toPath (tab) {
      this.nowPath = tab.routerPath
      this.$router.push({
        name: tab.routerPath
      })
    },

    enter (name) {
      this.$router.push(name)
    }
  }
}
</script>

<style lang="less">
#app {
  margin: 0 auto;
  min-width: 1240px;
  max-width: 1920px;
  overflow: hidden;
  background: #ffffff;
}

.header {
  height: 104px;
  background-color: #006ef2;
}

.headerContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  width: 1240px;
  height: 104px;

  .femLogo {
    width: 202px;
    height: 39px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .tabList {
    display: flex;

    .tabItem {
      margin-right: 63px;
      color: #fff;
      cursor: pointer;
    }

    .tabItemActive {
      padding-bottom: 3px;
      border-bottom: 1px solid #fff;
      font-weight: 700;
    }

    .tabItem:last-child {
      margin-right: 0;
    }
  }
}

.ask {
  height: 271px;
  background: url("./assets/common/askbg.png") no-repeat center;
  background-size: 1920px 271px;
  overflow: hidden;

  p {
    margin-top: 64px;
    font-size: 52px;
    font-weight: 400;
    color: #ffffff;
    letter-spacing: 1px;
    text-align: center;
  }

  .askButton {
    margin: 35px auto 0;
    width: 225px;
    height: 65px;
    border: 2px solid #ffffff;
    font-size: 26px;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    line-height: 65px;
    letter-spacing: 1px;
    cursor: pointer;
  }
}

.footer {
  height: 387px;
  background-color: #373d44;
}

.footerContainer {
  margin: 0 auto;
  width: 1240px;
  height: 100%;
  overflow: hidden;

  .infoList {
    margin-top: 66px;
    margin-bottom: 71px;
    display: flex;
    justify-content: space-between;

    .infoItem {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        margin-bottom: 27px;
        width: 72px;
        height: 72px;
      }

      span {
        font-size: 18px;
        font-weight: 300;
        color: #ffffff;
      }
    }
  }

  p {
    margin-top: 7px;
    font-size: 18px;
    font-weight: 300;
    color: #ffffff;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue